import { render, staticRenderFns } from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=template&id=517ce99c&scoped=true&"
import script from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto.vue?vue&type=style&index=0&id=517ce99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517ce99c",
  null
  
)

export default component.exports